"use strict";

exports.__esModule = true;
exports.RestAPI = void 0;
var _dissoc2 = _interopRequireDefault(require("ramda/src/dissoc"));
var _react = _interopRequireWildcard(require("react"));
var _Env = require("../../Env");
var _Auth = require("../../Auth");
var _Utils = require("../../../Utils");
var _DataAccessorContext = require("../DataInterface/DataAccessorContext");
var _eventSourcePolyfill = require("event-source-polyfill");
var _dec, _dec2, _class, _RestAPI;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Render-prop powered rest API for Vimana.
 */
var RestAPI = exports.RestAPI = (_dec = _Env.EnvContext.withContext, _dec2 = _Auth.AuthContext.withContext, _dec(_class = _dec2(_class = (_RestAPI = /*#__PURE__*/function (_Component) {
  function RestAPI() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      plantName: _this.props.plantName,
      tenantName: _this.props.auth.tenantName,
      // eslint-disable-next-line react/no-unused-state
      get: function get(url, plant) {
        return _this.makeRequest(url, {
          method: "GET"
        }, null, plant);
      },
      // eslint-disable-next-line react/no-unused-state
      put: function put(url, body) {
        return _this.makeRequest(url, {
          method: "PUT",
          body: body
        });
      },
      // eslint-disable-next-line react/no-unused-state
      post: function post(url, body, isFileUpload, signal) {
        return _this.makeRequest(url, {
          method: "POST",
          body: body,
          isFileUpload: isFileUpload
        }, signal);
      },
      patch: function patch(url, body) {
        return _this.makeRequest(url, {
          method: "PATCH",
          body: body
        });
      },
      // eslint-disable-next-line react/no-unused-state
      "delete": function _delete(url) {
        return _this.makeRequest(url, {
          method: "DELETE"
        });
      },
      // eslint-disable-next-line react/no-unused-state
      makeRequest: function makeRequest(url, options, signal) {
        return _this.makeRequest(url, options, signal);
      },
      getEventSource: function getEventSource(url) {
        return _this.getEventSource(url);
      }
    };
    return _this;
  }
  _inheritsLoose(RestAPI, _Component);
  RestAPI.getDerivedStateFromProps = function getDerivedStateFromProps(props, prevState) {
    var plantName = props.plantName,
      tenantName = props.auth.tenantName;
    if (plantName === prevState.plantName && tenantName === prevState.tenantName) {
      return null;
    }
    return {
      plantName: plantName,
      tenantName: tenantName
    };
  };
  var _proto = RestAPI.prototype;
  _proto.makeRequest = /*#__PURE__*/function () {
    var _makeRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(url, _ref, signal, plant) {
      var method, body, _ref$isFileUpload, isFileUpload, response, contentType, text, _body;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            method = _ref.method, body = _ref.body, _ref$isFileUpload = _ref.isFileUpload, isFileUpload = _ref$isFileUpload === void 0 ? false : _ref$isFileUpload;
            if (plant === void 0) {
              plant = undefined;
            }
            _context.n = 1;
            return fetch(this.normalizeUrl(url), {
              method: method,
              headers: this.getHeaders(this.getDefaultHeaders(plant), isFileUpload),
              body: this.getBody(body, isFileUpload),
              mode: "cors",
              redirect: "follow",
              signal: signal
            });
          case 1:
            response = _context.v;
            contentType = response.headers.get("content-type");
            if (response.ok) {
              _context.n = 4;
              break;
            }
            if (!(contentType && contentType.indexOf("application/json") !== -1)) {
              _context.n = 3;
              break;
            }
            _context.n = 2;
            return response.text();
          case 2:
            text = _context.v;
            try {
              _body = text ? JSON.parse(text) : null;
            } catch (parseError) {
              _body = {
                message: text
              };
            }
            throw new _Utils.FetchResponseError(_body || {
              message: "HTTP " + response.status + " with empty body",
              statusText: response.statusText
            }, response.status);
          case 3:
            throw new _Utils.FetchResponseError({
              message: response.statusText || "HTTP " + response.status + " with empty body",
              statusText: response.statusText
            }, response.status);
          case 4:
            if (!(response.status === 204 || response.status === 202)) {
              _context.n = 5;
              break;
            }
            return _context.a(2, true);
          case 5:
            if (!(contentType && contentType.indexOf("application/json") !== -1)) {
              _context.n = 7;
              break;
            }
            _context.n = 6;
            return response.json();
          case 6:
            return _context.a(2, _context.v);
          case 7:
            return _context.a(2, true);
        }
      }, _callee, this);
    }));
    function makeRequest(_x, _x2, _x3, _x4) {
      return _makeRequest.apply(this, arguments);
    }
    return makeRequest;
  }();
  _proto.getDefaultHeaders = function getDefaultHeaders(plant) {
    var _this$props = this.props,
      plantName = _this$props.plantName,
      auth = _this$props.auth;
    var token = auth.token;
    var tenant = plant || plantName;
    return Object.assign({}, tenant ? {
      "X-Tenant": tenant
    } : {}, {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json"
    });
  };
  _proto.getHeaders = function getHeaders(defaultHeaders, isFileUpload) {
    return isFileUpload ? (0, _dissoc2["default"])("Content-Type", defaultHeaders) : defaultHeaders;
  };
  _proto.getBody = function getBody(body, isFileUpload) {
    if (isFileUpload) {
      return body;
    }
    return body === undefined ? undefined : JSON.stringify(body);
  };
  _proto.getBaseUrl = function getBaseUrl() {
    var apiURL = this.props.env.apiURL;
    if (apiURL.charAt(apiURL.length - 1) === "/") {
      return apiURL;
    }
    return apiURL + "/";
  };
  _proto.normalizeUrl = function normalizeUrl(partialUrl) {
    var baseUrl = this.getBaseUrl();
    if (partialUrl.charAt(0) === "/") {
      return "" + baseUrl + partialUrl.slice(1);
    }
    return "" + baseUrl + partialUrl;
  };
  _proto.getEventSource = function getEventSource(url) {
    return new _eventSourcePolyfill.EventSourcePolyfill(this.normalizeUrl(url), {
      headers: this.getHeaders(this.getDefaultHeaders())
    });
  };
  _proto.render = function render() {
    // eslint-disable-next-line no-unused-vars
    var _this$props2 = this.props,
      env = _this$props2.env,
      auth = _this$props2.auth,
      children = _this$props2.children;
    return /*#__PURE__*/_react["default"].createElement(_DataAccessorContext.DataAccessorContext.Provider, {
      api: this.state
    }, children(this.state));
  };
  return RestAPI;
}(_react.Component), _RestAPI.defaultProps = {
  env: undefined,
  auth: undefined
}, _RestAPI)) || _class) || _class);